import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-219q-16 0-28-12t-11-28q0-17 11-29 12-11 28-11h670q16 0 28 12 12 11 12 28t-12 29q-12 11-28 11H145Zm0-221q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h670q16 0 28 12 12 11 12 28t-12 28q-12 12-28 12H145Zm0-221q-16 0-28-12t-11-28q0-17 11-29 12-11 28-11h670q16 0 28 12 12 11 12 28t-12 29q-12 11-28 11H145Z"/>',
  f: '<path d="M145-219q-16 0-28-12t-11-28q0-17 11-29 12-11 28-11h670q16 0 28 12 12 11 12 28t-12 29q-12 11-28 11H145Zm0-221q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h670q16 0 28 12 12 11 12 28t-12 28q-12 12-28 12H145Zm0-221q-16 0-28-12t-11-28q0-17 11-29 12-11 28-11h670q16 0 28 12 12 11 12 28t-12 29q-12 11-28 11H145Z"/>',
};

export default data;
